const DO_NOT_CARRY_PARAMS = ["search", "page"];

export const setFiltersDefaultValue = (
  urlParams,
  filterTypes,
  setFiltersChosen,
  setFiltersChosenPreview
) => {
  const _filtersChosen = {};
  const _filtersChosenPreview = {};

  filterTypes.forEach((filter) => {
    // check if there is filter value in url params
    if (!!urlParams[filter.field_name]) {
      // set _filtersChosen with filter value from url
      _filtersChosen[filter.field_name] = urlParams[filter.field_name];

      // set _filtersChosenPreview with filter value from list_meta filters
      // if: choice field --> select value from choices
      if (filter.field_type === "ModelChoiceField" && !!filter.choices.length) {
        let previewValue = "";
        // loop through choices to get preview value
        filter.choices.forEach((choice) => {
          if (choice[0] === urlParams[filter.field_name]) {
            previewValue = choice[1];
            return;
          }
        });
        // set preview value
        _filtersChosenPreview[filter.field_name] = previewValue;
      } else {
        // else: set filter preview value from url direct same as _filtersChosen
        _filtersChosenPreview[filter.field_name] = urlParams[filter.field_name];
      }
    } else {
      // set default value empty
      _filtersChosen[filter.field_name] = "";
      _filtersChosenPreview[filter.field_name] = "";
    }
  });

  setFiltersChosen(_filtersChosen);
  setFiltersChosenPreview(_filtersChosenPreview);
};

export const isCountrySupported = (countryCode, countriesList) => {
  let isSupported = false;

  countriesList.forEach((country) => {
    if (country.code === countryCode) {
      isSupported = true;
    }
  });

  return isSupported;
};

export const getCarriedQueryParams = (query) => {
  const queryClone = { ...query };

  // remove query params that shouldn't be carried
  // on route change
  DO_NOT_CARRY_PARAMS.forEach((key) => {
    delete queryClone[key];
  });

  return queryClone;
};
